import { MantineThemeColors } from '@mantine/core';

// Aggregation of colors
export const DEFAULT_COLORS = {
  dark: [
    '#C1C2C5',
    '#A6A7AB',
    '#909296',
    '#5c5f66',
    '#373A40',
    '#2C2E33',
    '#25262b',
    '#1A1B1E',
    '#141517',
    '#101113',
  ],

  red: [
    '#fff5f5',
    '#ffe3e3',
    '#ffc9c9',
    '#ffa8a8',
    '#ff8787',
    '#ff6b6b',
    '#fa5252',
    '#f03e3e',
    '#e03131',
    '#c92a2a',
  ],

  pink: [
    '#fff0f6',
    '#ffdeeb',
    '#fcc2d7',
    '#faa2c1',
    '#f783ac',
    '#f06595',
    '#e64980',
    '#d6336c',
    '#c2255c',
    '#a61e4d',
  ],

  grape: [
    '#f8f0fc',
    '#f3d9fa',
    '#eebefa',
    '#e599f7',
    '#da77f2',
    '#cc5de8',
    '#be4bdb',
    '#ae3ec9',
    '#9c36b5',
    '#862e9c',
  ],

  violet: [
    '#f3f0ff',
    '#e5dbff',
    '#d0bfff',
    '#b197fc',
    '#9775fa',
    '#845ef7',
    '#7950f2',
    '#7048e8',
    '#6741d9',
    '#5f3dc4',
  ],

  indigo: [
    '#edf2ff',
    '#dbe4ff',
    '#bac8ff',
    '#91a7ff',
    '#748ffc',
    '#5c7cfa',
    '#4c6ef5',
    '#4263eb',
    '#3b5bdb',
    '#364fc7',
  ],

  cyan: [
    '#e3fafc',
    '#c5f6fa',
    '#99e9f2',
    '#66d9e8',
    '#3bc9db',
    '#22b8cf',
    '#15aabf',
    '#1098ad',
    '#0c8599',
    '#0b7285',
  ],

  teal: [
    '#e6fcf5',
    '#c3fae8',
    '#96f2d7',
    '#63e6be',
    '#38d9a9',
    '#20c997',
    '#12b886',
    '#0ca678',
    '#099268',
    '#087f5b',
  ],

  green: [
    '#ebfbee',
    '#d3f9d8',
    '#b2f2bb',
    '#8ce99a',
    '#69db7c',
    '#51cf66',
    '#40c057',
    '#37b24d',
    '#2f9e44',
    '#2b8a3e',
  ],

  lime: [
    '#f4fce3',
    '#e9fac8',
    '#d8f5a2',
    '#c0eb75',
    '#a9e34b',
    '#94d82d',
    '#82c91e',
    '#74b816',
    '#66a80f',
    '#5c940d',
  ],

  orange: [
    '#fff4e6',
    '#ffe8cc',
    '#ffd8a8',
    '#ffc078',
    '#ffa94d',
    '#ff922b',
    '#fd7e14',
    '#f76707',
    '#e8590c',
    '#d9480f',
  ],
  // theme colors ==> extends some defaults (gray, blue, yellow)
  gray: [
    '#fafafa',
    '#eeeeee',
    '#cccccc',
    '#bbbbbb',
    '#aaaaaa',
    '#888888',
    '#666666',
    '#333333',
    '#222222',
    '#111111',
  ],

  cobalt: [
    '#edf1fc',
    '#c8d3f4',
    '#aebeef',
    '#89a0e8',
    '#728de4',
    '#4f71dd',
    '#234dd4',
    '#0D32AA',
    '#081E66',
    '#051444',
  ],

  tangerine: [
    '#fff7f3',
    '#ffe7d9',
    '#ffdcc6',
    '#ffccac',
    '#ffc29c',
    '#ffb383',
    '#ffa064',
    '#e8925b',
    '#b57247',
    '#8c5837',
  ],

  blue: [
    '#ebecf0',
    '#c1c5d1',
    '#a3a9ba',
    '#79819b',
    '#5f6987',
    '#374369',
    '#051444',
    '#05123e',
    '#040e30',
    '#030b25',
  ],

  yellow: [
    '#FEF9EB',
    '#FDEEC1',
    '#FCE5A3',
    '#fbd979',
    '#fad25f',
    '#f9c737',
    '#F8B905',
    '#E2A805',
    '#b08304',
    '#886603',
  ],
  lightBlue: [
    ' #f8fdff',
    '#e8f8ff',
    '#ddf4ff',
    '#cdefff',
    '#c4ecff',
    '#b5e7ff',
    '#a3e1ff',
    '#94cde8',
    '#74a0b5',
    '#5a7c8c',
  ],

  mint: [
    '#f4fcf8',
    '#dcf4e9',
    '#cbefde',
    '#b3e8cf',
    '#a5e3c6',
    '#8edcb8',
    '#72D3A6',
    '#68C097',
    '#519676',
    '#3F745B',
  ],

  cerise: [
    '#fdf1f4',
    '#f8d4de',
    '#f5c0ce',
    '#f1a3b7',
    '#ee91a9',
    '#ea7594',
    '#e55279',
    '#d04b6e',
    '#a33a56',
    '#7e2d43',
  ],

  rose: [
    '#fef9fa',
    '#fdecf0',
    '#fce2e9',
    '#fad5df',
    '#f9cdd9',
    '#f8c1cf',
    '#f6b1c3',
    '#e0a1b1',
    '#af7e8a',
    '#87616b',
  ],

  slate: [
    '#eeeff0',
    '#cbccd1',
    '#b1b4ba',
    '#8e919b',
    '#787c87',
    '#565b69',
    '#2c3244',
    '#282e3e',
    '#1f2430',
    '#181c25',
  ],

  white: [
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
    '#ffffff',
  ],
} as MantineThemeColors;

// 90,80,60,40,30,20, 0, 20,40,60
